import React from 'react';

import Image from 'marketing-website/components/modules/Image';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/handoff/assets';

export default function HandoffArtwork() {
  return (
    <MediaMultipleImages
      fallbackImageAlt="Design to development, automated"
      fallbackImageMaxWidth={assets.handoffArtwork.maxWidth}
      fallbackImageSrc={assets.handoffArtwork.src}
    >
      <ParallaxWrapper speed={2}>
        <Shape width={424} height={288} type="rectangle" color="lightGreen" />
        <Pattern type="shortRectangle" color="green" top="30%" left="10%" />
      </ParallaxWrapper>
      <ParallaxWrapper speed={0.7}>
        <Image
          {...assets.fills}
          borderRadius="m"
          left="50%"
          top="16%"
          position="absolute"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={1}>
        <Image
          {...assets.black}
          borderRadius="m"
          left="4%"
          position="absolute"
          top="50%"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={1.4}>
        <Image
          {...assets.cssBar}
          hasShadow={false}
          left="32%"
          top="12%"
          position="absolute"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={2}>
        <Image
          {...assets.avatar}
          position="absolute"
          top="40%"
          left="25%"
          borderRadius="m"
        />
      </ParallaxWrapper>
    </MediaMultipleImages>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/HandoffArtwork/index.js